import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const BlogsContext = createContext(null);

// Blog yazıları /api/blogs.php üzerinden (ZeoConnectReceiver → backend-core
// tenant_blogs tablosu) çekilir — panelden "Blog Yönetimi"nde eklenen
// yazılar. Liste yalnızca özet alanları taşır (title/slug/excerpt/cover);
// tam içerik yalnızca detay sayfası açıldığında ayrıca istenir (bkz.
// getBlogPost) — liste isteğini hafif tutmak için.
export function BlogsProvider({ children }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const postCache = useRef(new Map());

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/api/blogs.php");
        const json = await res.json().catch(() => null);
        if (!cancelled && res.ok && json?.status !== "error" && Array.isArray(json?.blogs)) {
          setPosts(json.blogs);
        }
      } catch {
        // ZEO Connect'e ulaşılamadı — blog bölümü boş görünür, site geri kalanı etkilenmez.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const getBlogPost = useCallback(async (slug) => {
    if (postCache.current.has(slug)) return postCache.current.get(slug);
    try {
      const res = await fetch(`/api/blogs.php?slug=${encodeURIComponent(slug)}`);
      const json = await res.json().catch(() => null);
      const post = res.ok && json?.status !== "error" ? json?.blog ?? null : null;
      postCache.current.set(slug, post);
      return post;
    } catch {
      return null;
    }
  }, []);

  return (
    <BlogsContext.Provider value={{ posts, loading, getBlogPost }}>
      {children}
    </BlogsContext.Provider>
  );
}

export function useBlogs() {
  const ctx = useContext(BlogsContext);
  if (!ctx) throw new Error("useBlogs must be used within a BlogsProvider");
  return ctx;
}
